import { render, staticRenderFns } from "./ConfigGraduateCurriculumFee.vue?vue&type=template&id=a15c336e"
import script from "./ConfigGraduateCurriculumFee.vue?vue&type=script&lang=js"
export * from "./ConfigGraduateCurriculumFee.vue?vue&type=script&lang=js"
import style0 from "./ConfigGraduateCurriculumFee.vue?vue&type=style&index=0&id=a15c336e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports